import styled from 'styled-components';

export const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
`;

export const UsersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 600;
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const TabWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background: ${({ theme }) => theme?.colors?.tabBackground ?? '#f1f1f1'};
  border-radius: 8px;
  padding: 4px;
`;

export const IconButton = styled.button`
  border: 1px solid
    ${({ variant }) => {
      if (variant === 'edit') return '#3B82F6';
      if (variant === 'test') return '#22C55E';
      if (variant === 'promote') return '#86efac';
      return '#fca5a5';
    }};

  background-color: ${({ variant }) => {
    if (variant === 'edit') return '#E6F0FF';
    if (variant === 'test') return '#E6F9F0';
    if (variant === 'promote') return '#dcfce7';
    return '#fee2e2';
  }};

  color: ${({ variant }) => {
    if (variant === 'edit') return '#2563EB';
    if (variant === 'test') return '#16A34A';
    if (variant === 'promote') return '#16a34a';
    return '#dc2626';
  }};

  cursor: pointer;
  padding: 4px;
  border-radius: 10px;
  margin-right: 6px;
`;
